// extracted by mini-css-extract-plugin
module.exports = {"bm-section":"bm-section","content-match-section":"content-match-section","title":"title","soccer-content-item":"soccer-content-item"};